import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BottomSheetContentLayout, Menu } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetMobileSortPickerTID = (parentTestId)=>getTestIds(parentTestId);
export const MobileSortPicker = (param)=>{
    let { testId, sortOptions, selectedSortOptionId, onSelect } = param;
    const { MobileSortPickerTID } = useMemo(()=>GetMobileSortPickerTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: {
            title: 'Sort by'
        },
        children: /*#__PURE__*/ _jsx(Menu, {
            testId: MobileSortPickerTID.Root(),
            items: sortOptions.map((option)=>({
                    id: option.id,
                    testId: MobileSortPickerTID.SortOption(option.id),
                    title: option.label,
                    selected: option.id === selectedSortOptionId,
                    onClick: ()=>onSelect(option)
                }))
        })
    });
};
